 import React, { useState ,useEffect } from 'react';
 import axios from "axios";
 
 const Pokemonapi = () => {
     const [num , setNum] = useState(1);
     const [name , setName] = useState(1);
     const [moves , setMoves] = useState(1);

     useEffect(() => {
         async function getData(){
             const res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${num}`);
             //console.log(res.data.name);
             setName(res.data.name);
             setMoves(res.data.moves.length);
         }
         getData();
     });
   return <>
   <h1>You select {num}</h1>
   <h1>My name is {name}</h1>
   <h1>I have {moves} moves</h1>
<select value={num} onChange={ (event) =>{
    setNum(event.target.value)
}}>
    <option value='1'> 1 </option>
    <option value='25'> 25 </option>
    <option value='3'> 3 </option>
    <option value='4'> 4 </option>
    <option value='5'> 5 </option>
</select>

   </>;
 };
 
 export default Pokemonapi;
 